import { createReducer } from '@reduxjs/toolkit';
import { electronActions } from './electron.actions';
const initialState = {
    connected: false,
};
export const electronReducer = createReducer(initialState, (builder) => builder.addCase(electronActions.connected, (state, action) => {
    state.connected = action.payload.connected;
}));
